import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Arco Design
import ArcoVue from '@arco-design/web-vue';
import '@arco-design/web-vue/dist/arco.css';

// 自定义 CSS
import './assets/css/base.css';
// 阿里 icon
import './assets/css/icon/iconfont.css';
// typo.css
import './assets/css/typo.css';

// v-viewer
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';

// 字体覆盖 - 必须最后加载，确保覆盖所有其他 CSS
import './assets/css/font-override.css';

// 自定义指令
import { registerDirectives } from './util/directive';

// 日期时间格式化
import { registerDateMethods } from './util/dateTimeFormatUtils';

// 创建 Vue 3 应用
const app = createApp(App);

// 使用插件
app.use(ArcoVue);
app.use(VueViewer);
app.use(store);
app.use(router);

// 注册自定义指令
registerDirectives(app);

// 注册日期方法
registerDateMethods(app);

// 封装全局方法 (Vue 3 使用 globalProperties)
import { Message } from '@arco-design/web-vue';

app.config.globalProperties.msgSuccess = function (msg) {
    Message.success(msg);
};

app.config.globalProperties.msgError = function (msg) {
    Message.error(msg);
};

app.config.globalProperties.msgInfo = function (msg) {
    Message.info(msg);
};

// 滚动至页面顶部
const cubic = (value) => Math.pow(value, 3);
const easeInOutCubic = (value) =>
    value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;

app.config.globalProperties.scrollToTop = function () {
    const el = document.documentElement;
    const beginTime = Date.now();
    const beginValue = el.scrollTop;
    const rAF = window.requestAnimationFrame || ((func) => setTimeout(func, 16));
    const frameFunc = () => {
        const progress = (Date.now() - beginTime) / 500;
        if (progress < 1) {
            el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
            rAF(frameFunc);
        } else {
            el.scrollTop = 0;
        }
    };
    rAF(frameFunc);
};

// 挂载应用
app.mount('#app');

// 使用路由钩子来设置页面标题
router.afterEach((to) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = 'Navigation';
    }
});
